export const MAINTENANCE_PLANS = [
  { id: 'basic', name: 'Basic Plan', listedAnnualPrice: '$149' },
  { id: 'premium', name: 'Premium Plan', listedAnnualPrice: '$299' },
  { id: 'elite', name: 'Elite Plan', listedAnnualPrice: '$449' },
  { id: 'undecided', name: 'Help choosing a plan', listedAnnualPrice: null },
] as const;
export const MAINTENANCE_PLAN_IDS = ['basic', 'premium', 'elite', 'undecided'] as const;
export type MaintenancePlanId = typeof MAINTENANCE_PLAN_IDS[number];
export function getMaintenancePlan(id: string | undefined) {
  return MAINTENANCE_PLANS.find(plan => plan.id === id);
}
export const PLAN_REQUEST_NOTICE = 'Our team reviews your request and confirms the plan, scope, price and any applicable taxes before sending an invoice through Jobber. Sending this form does not make a payment, activate a plan or enroll you in automatic billing.';
